import axios from '../../services/axios';

function updateQuiz(quiz) {
  const params = {
    quiz,
  };

  return axios({
    method: 'PUT',
    url: `/quizzes/${quiz.id}/`,
    params,
  });
}

function finishQuiz(quiz) {
  const params = quiz;

  const { files } = params;

  const data = new FormData();

  files.forEach((file) => {
    data.append('quiz[documents_attributes][][file]', file, file.name);
  });

  delete params.files;

  Object.entries(params).forEach(([key, value]) => {
    if (!value) { return; }

    data.append(`quiz[${key}]`, value);
  });

  return axios({
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    url: `/quizzes/${quiz.id}/finish/`,
    data,
  });
}

function getQuiz() {
  return axios({
    method: 'GET',
    url: '/quizzes/?format=json',
  });
}

const api = {
  getQuiz,
  finishQuiz,
  updateQuiz,
};

export default api;
